module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (83).5c4503c1.jpg";